module.exports = __webpack_public_path__ + "64ac726e73ff6cd94b55bb93d84c27d3.pdf";